<template>
  <div class="drawer-container">
    <div>
      <h3 class="drawer-title">页面样式设置</h3>

      <div class="drawer-item">
        <span>主题色</span>
        <theme-picker
          style="float: right; height: 26px; margin: -3px 8px 0 0"
          @change="themeChange"
        />
      </div>

      <div class="drawer-item">
        <span>开启标签</span>
        <el-switch v-model="tagsView" class="drawer-switch" />
      </div>
<!-- 
      <div class="drawer-item">
        <span>固定头部</span>
        <el-switch v-model="fixedHeader" class="drawer-switch" />
      </div> -->

      <!-- <div class="drawer-item">
        <span>系统Logo</span>
        <el-switch v-model="sidebarLogo" class="drawer-switch" />
      </div> -->
      <div class="drawer-item">
        <span>开启通栏</span>
        <!-- <el-select v-model="sidebarView" size="mini" class="drawer-select">
          <el-option label="horizontal" value="horizontal"></el-option>
          <el-option label="vertical" value="vertical"></el-option>
        </el-select> -->
        <el-switch v-model="sidebarView" class="drawer-switch" />
      </div>
    </div>
  </div>
</template>

<script>
import {getUserConfig,postUserConfig} from '@/api/user'
import ThemePicker from "@/components/ThemePicker";

export default {
  components: { ThemePicker },
  data() {
    return {};
  },
  computed: {
    fixedHeader: {
      get() {
        return this.$store.state.settings.fixedHeader;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "fixedHeader",
          value: val,
        });
      },
    },
    tagsView: {
      get() {
        return this.$store.state.settings.tagsView;
      },
      set(val) {
        postUserConfig({tagsView:val})
        this.$store.dispatch("settings/changeSetting", {
          key: "tagsView",
          value: val,
        });
      },
    },
    // sidebarLogo: {
    //   get() {
    //     return this.$store.state.settings.sidebarLogo;
    //   },
    //   set(val) {
    //     this.$store.dispatch("settings/changeSetting", {
    //       key: "sidebarLogo",
    //       value: val,
    //     });
    //   },
    // },
    sidebarView: {
      get() {
        return this.$store.state.settings.sidebarView;
      },
      set(val) {
        postUserConfig({sidebarView:val})
        this.$store.dispatch("settings/changeSetting", {
          key: "sidebarView",
          value: val,
        });
      },
    },
  },
  created(){
    this.getUserConfigHandler()
  },
  methods: {
    async themeChange(val) {
      // console.log(val);
      // await postUserConfig({theme:val})
      this.$store.dispatch("settings/changeSetting", {
        key: "theme",
        value: val,
      });
    },
    async getUserConfigHandler(){
      let {code,data} = await getUserConfig()
      // console.log('getUser',data);
      for(let key in data){
        this.$store.dispatch("settings/changeSetting", {
          key,
          value: data[key],
        });
      }
      // console.log(this.$store.state.settings);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
  .drawer-item-select {
    width: 100%;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .drawer-select {
    width: 110px;
    font-size: 12px;
  }
}
</style>
